import { render } from "./CelebrationInfo.vue?vue&type=template&id=4da0cbee&scoped=true&lang=pug"
import script from "./CelebrationInfo.vue?vue&type=script&lang=js"
export * from "./CelebrationInfo.vue?vue&type=script&lang=js"

import "./CelebrationInfo.vue?vue&type=style&index=0&id=4da0cbee&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4da0cbee"]])

export default __exports__